import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'

import Element from 'element-ui'

import './assets/styles/element-ui-variables.scss'
import './assets/styles/app.scss'

import './plugins'
import './components'

import App from './App.vue'
import router from './router'
import store from './store'

/**
 * Internationalization
 */
import { i18n } from './lang'

/**
 * Permission Control
 */
import './permission'

/**
 * Vue Global Filter
 */
import './filter/global'

Vue.use(VueCompositionApi)
Vue.use(Element, {
  size: 'mini', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value),
})

Vue.config.productionTip = false
Vue.config.devtools = true
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
